import { render, staticRenderFns } from "./video-index.vue?vue&type=template&id=3d422d8a&scoped=true&"
import script from "./video-index.vue?vue&type=script&lang=js&"
export * from "./video-index.vue?vue&type=script&lang=js&"
import style0 from "./video-index.vue?vue&type=style&index=0&id=3d422d8a&prod&lang=css&"
import style1 from "./video-index.vue?vue&type=style&index=1&id=3d422d8a&prod&scoped=true&lang=css&"
import style2 from "./video-index.vue?vue&type=style&index=2&id=3d422d8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d422d8a",
  null
  
)

export default component.exports